import { createRouter, createWebHistory } from 'vue-router'

// Auth
import SplashView from '../views/splash/SplashView.vue'
import LoginView from '../views/auth/LoginView.vue'
import RegisterView from '../views/auth/RegisterView.vue'
import ForgotPasswordView from '../views/auth/ForgotPasswordView.vue'
import ResetPasswordView from '../views/auth/ResetPasswordView.vue'

// Home
import HomeView from '../views/home/HomeView.vue'

// Noticias
import NoticiaDetailView from '../views/noticias/NoticiaDetailView.vue'

// Express
import ExpressView from '../views/express/ExpressView.vue'
import ExpressDetailView from '../views/express/EspressDetailView.vue'

// Radio, MiZona
import RadioView from '../views/radio/RadioView.vue'
import MizonaView from '../views/mizona/MizonaView.vue'

//Tendencia
import TendenciaView from '../views/tendencia/TendenciaView.vue'

//Mi Perfil
import EditPerfilView from '../views/miperfil/EditPerfilView.vue'

//Mi Suscripcion
import MisuscripcionView from '../views/misuscripcion/MisuscripcionView.vue'

//Favoritos
import FavoritosView from '../views/mizona/FavoritosView.vue'

//Newsletters
import NewslettersView from '../views/mizona/NewslelletrsView.vue'

//Avisolegal
import AvisolegalView from '../views/aviso/AvisolegalView.vue'

//Politica
import PoliticaView from '../views/politica/PoliticaView.vue'

//Anuncia
import AnunciaView from '../views/anuncia/AnunciaView.vue'

//Quienes Somos
import QuienessomosView from '../views/quienessomos/QuienessomosView.vue'

//Equipo Editorial
import EquipoeditorialView from '../views/equipo/EquipoeditorialView.vue'

//Category Show
import CategoryDetailView from '../views/categories/CategorydetailView.vue'

const isAuthenticated = () => {
  return !!localStorage.getItem('auth_token')
}

const routes = [
  // Splash
  {
    path: '/',
    name: 'Splash',
    component: SplashView
  },
  
  // Rutas públicas
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPasswordView
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPasswordView
  },
  
  // Rutas protegidas (requieren autenticación)
  {
    path: '/home',
    name: 'Home',
    component: HomeView,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) {
        next()
      } else {
        next('/login')
      }
    }
  },
  {
    path: '/noticia/:slug',
    name: 'NoticiaDetail',
    component: NoticiaDetailView,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) {
        next()
      } else {
        next('/login')
      }
    }
  },
  {
    path: '/express',
    name: 'Express',
    component: ExpressView,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) {
        next()
      } else {
        next('/login')
      }
    }
  },
  {
    path: '/express/:slug',
    name: 'ExpressDetail',
    component: ExpressDetailView,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) {
        next()
      } else {
        next('/login')
      }
    }
  },
  {
    path: '/tendencia',
    name: 'Tendencia',
    component: TendenciaView,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) {
        next()
      } else {
        next('/login')
      }
    }
  },
  {
    path: '/radio',
    name: 'Radio',
    component: RadioView,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) {
        next()
      } else {
        next('/login')
      }
    }
  },
  {
    path: '/mizona',
    name: 'Mizona',
    component: MizonaView,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) {
        next()
      } else {
        next('/login')
      }
    }
  },
   {
    path: '/editar-perfil',
    name: 'EditPerfil',
    component: EditPerfilView,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) {
        next()
      } else {
        next('/login')
      }
    }
  },
   {
    path: '/misuscripcion',
    name: 'Misuscripcion',
    component: MisuscripcionView,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) {
        next()
      } else {
        next('/login')
      }
    }
  },
  {
    path: '/favoritos',
    name: 'favoritos',
    component: FavoritosView,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) {
        next()
      } else {
        next('/login')
      }
    }
  },
  {
    path: '/newsletters',
    name: 'newsletters',
    component: NewslettersView,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) {
        next()
      } else {
        next('/login')
      }
    }
  },
  {
    path: '/avisolegal',
    name: 'avisolegal',
    component: AvisolegalView,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) {
        next()
      } else {
        next('/login')
      }
    }
  },
  {
    path: '/policy',
    name: 'policy',
    component: PoliticaView,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) {
        next()
      } else {
        next('/login')
      }
    }
  },
  {
    path: '/anunciaconnosotros',
    name: 'anunciaconnosotros',
    component: AnunciaView,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) {
        next()
      } else {
        next('/login')
      }
    }
  },
  {
    path: '/quienes-somos',
    name: 'quienes-somos',
    component: QuienessomosView,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) {
        next()
      } else {
        next('/login')
      }
    }
  },
  {
    path: '/equipo-editorial',
    name: 'equipo-editorial',
    component: EquipoeditorialView,
    beforeEnter: (to, from, next) => {
      if (isAuthenticated()) {
        next()
      } else {
        next('/login')
      }
    }
  },
    {
    path: '/categoria/:slug',
    name: 'categoria',
    component: CategoryDetailView,
     beforeEnter: (to, from, next) => {
      if (isAuthenticated()) {
        next()
      } else {
        next('/login')
      }
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,

  scrollBehavior(to, from, savedPosition) {

    if (savedPosition) {
      return savedPosition
    }

    return { top: 0, behavior: 'smooth' }
  }
})

export default router